import http from '@/biz/http.mjs'

export default {
    create: (args) => http.post('/basmapvers', args),

    fetchIdByRev: async ({bizNodeType, pkid, rev}) => {
        const {pkid: id} = await http.get(
            '/basmapvers/judgeVer',
            {bizNodeType, pkid, rev}
        )

        return id
    },

    list: ({dataId}) => http.get('/basmapvers', {dataId}),

    read: async ({pkid}) => {
        const {
            crtName: rlsName,
            crtTime: rlsTime,
            dataName,
            dataMap,
            dataVer: mapRev,
        } = await http.get(`/basmapvers/${pkid}`)

        const map = JSON.parse(dataMap)

        const mapName = (() => {
            const {mapTypeCode} = map.data

            const name = {
                SA_MAP: '模型总图',
                _BA_MAP: '业务结构',
                _FA_MAP: '功能结构',
                _UA_MAP: '入口结构',
            }[mapTypeCode]

            return name ?? dataName
        })()

        Object.assign(map.data, {
            crtName: '',
            mapName,
            mapRev,
            rlsName,
            rlsTime,
            snapshotId: pkid,
            stsCode: '',
            uptName: '',
        })

        return map
    },

    readByRev: async args => {
        const {
            crtName: rlsName,
            crtTime: rlsTime,
            dataName: mapName,
            dataMap,
            dataVer: mapRev,
            ...data
        } = await http.get('/basmapvers/ver', args)

        const map = JSON.parse(dataMap)

        Object.assign(map.data, {
            ...data,
            crtName: '',
            mapName,
            mapRev,
            rlsName,
            rlsTime,
            stsCode: '',
            uptName: '',
        })

        return map
    },
}
